module.exports = __webpack_public_path__ + "img/170-2408f9.png";